import { ActionType, PayloadErrorType } from 'types/reduxTypes';
import { CLEAR_HARDWARE_DEVICES, SET_AUDIO_DEVICES, SET_CAMERA, SET_MICROPHONE, SET_VIDEO_DEVICES } from '../constants';
import { DeviceType } from 'types/hardwareTypes';
import { HardwareStoreType } from 'types/stateTypes';

export type HardwarePayloadType = DeviceType[] | string | null | PayloadErrorType;

const initialState: HardwareStoreType = {
  audioDevices: [],
  camera: null,
  microphone: null,
  videoDevices: [],
};

export default (state = initialState, action: ActionType<HardwarePayloadType>): HardwareStoreType => {
  switch (action.type) {
    case CLEAR_HARDWARE_DEVICES: {
      return { ...initialState };
    }

    case SET_AUDIO_DEVICES: {
      return { ...state, audioDevices: action.payload as DeviceType[] };
    }
    case SET_VIDEO_DEVICES: {
      return { ...state, videoDevices: action.payload as DeviceType[] };
    }
    case SET_CAMERA: {
      return { ...state, camera: action.payload as string | null };
    }
    case SET_MICROPHONE: {
      return { ...state, microphone: action.payload as string | null };
    }

    default: {
      return state;
    }
  }
};
